import React from "react";
import { useAuth } from "../../../../context/security/AuthProvider";
import {
  useMovement,
  useDispatchTestExit,
  useActionsTestExit,
} from "../../../../context/inventory/TestFormExitProvider";
import "./testExit.css";
import { LineTitle } from "../../article";
import StatusEntry from "../../entry/form/StatusEntry";
import Select from "react-select";
import { types } from "../../../../reducers/inventory/testExitReducer";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import {
  FORMAT_DATE_MOMENT,
  STATUS_EXCUTED,
  STATUS_IN_PROGRESS,
  TYPE_TESTS,
} from "../../../../api/constant";
import Moment from "react-moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faGasPump,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  formatNumberCOP,
  getTypeMeasure,
} from "../../../../utilities/app.utilities";
import PanelDocumentObservation from "../../../app/PanelDocumentObservations";
import { alertWarning } from "../../../../utilities/alerts.utilities";
const TestExit = () => {
  const auth = useAuth();
  const state = useMovement();
  const dispatch = useDispatchTestExit();
  const actions = useActionsTestExit();

  const {
    item_selected_out: { abreviature, quantity_consume, test_detail_id },
    test: { version, description, name, type },
    movement: {
      movement_id,
      status_id,
      warehouse_id,
      created_at,
      quantity,
      observation: { observations },
      document: { documents },
    },
    inventory_item: { items: list_inventory },
  } = state;
  const { warehouses } = auth.user;
  const items = state.items_version.items;
  const getTypeName = (type) => {
    const filter = TYPE_TESTS.filter((t) => t.code === type);
    return filter.length > 0 ? filter[0].name : null;
  };

  const setInputMovement = (field, value) => {
    dispatch({
      type: types.SET_PAYLOAD_MOVEMENT,
      payload: { ...state.movement, [field]: value },
    });
  };
  const getCurrentConsume = () => {
    return list_inventory.reduce(
      (accumulator, currentValue) =>
        parseFloat(accumulator) +
        parseFloat(currentValue.consume === "" ? 0 : currentValue.consume),
      0
    );
  };
  const refill = (stock, index_inventory) => {
    if (stock === 0) {
      alertWarning("No hay inventario disponible");
      return false;
    }
    const detail_test = items.filter(
      (test_detail) => test_detail.id === test_detail_id
    );

    if (detail_test.length > 0) {
      const detail = detail_test[0];
      const toConsume = quantity * detail.quantity;
      if (detail.out_stock == toConsume) {
        alertWarning("No puedes consumir más de lo establecido en el test");
        return false;
      }

      const remaining = toConsume - detail.out_stock; //faltante

      if (remaining > 0) {
        const final_consume = stock >= remaining ? remaining : stock;
        detail.out_stock =parseFloat(detail.out_stock) + parseFloat(final_consume);
        actions.setConsume(final_consume, index_inventory);
        const item_inventory = state.inventory_item.items[index_inventory];
        actions.createOutMovementDetail(movement_id, {
          value_unit_conversion: item_inventory.value_unit_conversion,
          item_id: item_inventory.item_id,
          consume: final_consume.toFixed(2),
          lote: item_inventory.lote,
          test_detail_id,
          date_expired: item_inventory.date_expired,
        });
      }
    }
  };

  const filter_list_inventory = list_inventory.filter((item)=> item.consume!=="0")

  return (
    <section className="container-fluid">
      <LineTitle title={"Salida de kits"}>
        <StatusEntry status_id={status_id} />
      </LineTitle>
      <section style={{ marginTop: "12px" }} className="container-header-test-exit">
        <div className="form-group flex ">
          <label style={{marginTop:"2rem"}} className="font1 ">ID de salida</label>
        </div>
        <div style={{marginRight:"2rem"}} className="form-group ">
          <label className="control-label">&nbsp;</label>
          <div disabled className="form-control">
            &nbsp;{movement_id}
          </div>
        </div>
        <div className="form-group ">
          <label className="control-label">&nbsp;</label>
          <div disabled className="form-control">
            &nbsp;
            <Moment format={FORMAT_DATE_MOMENT}>{created_at}</Moment>
          </div>
        </div>
        <div className="form-group">
          <label className="control-label">Tipo de prueba</label>
          <div disabled className="form-control">
            &nbsp;
            {getTypeName(type)}
          </div>
        </div>
        <div className="form-group" >
          <label className="control-label">
            Nombre o referencia de la prueba
          </label>
          <div title={name} disabled className="form-control no-long-txt">
            &nbsp;
            {name}
          </div>
        </div>
        <div className="form-group  ">
          <label className="control-label">Versión</label>
          <div disabled className="form-control">
            &nbsp;
            {version}
          </div>
        </div>
        <div className="form-group ">
          <label className="control-label">Descripción</label>
          <div
            title={description}
            disabled
            className="form-control no-long-txt"
          >
            &nbsp;
            {description}
          </div>
        </div>
        <div style={{minWidth:"14rem"}} className="form-group">
          <label className="control-label">Almacén</label>
          <Select
            value={warehouses.filter((w) => w.id === warehouse_id)}
            placeholder="Almacén"
            getOptionLabel={(option) => option.code + " - " + option.name}
            getOptionValue={(option) => option.id}
            options={warehouses}
            styles={customStyles}
            isDisabled={movement_id}
            onChange={(e) => setInputMovement("warehouse_id", e ? e.id : null)}
          />
        </div>
        <div style={{maxWidth:"7rem"}} className="form-group">
          <label className="control-label">Kits a consumir</label>
          <input
            min="1"
            onChange={(e) => setInputMovement("quantity", e.target.value)}
            value={quantity}
            disabled={movement_id}
            className="form-control"
            type="number"
          />
        </div>
        {!movement_id && (
          <div className="form-group">
            <label className="control-label">&nbsp;</label>
            <div
              onClick={() => actions.createExitVersion()}
              className="btn-default"
            >
              <FontAwesomeIcon icon={faPlus} />
              &nbsp;Crear
            </div>
          </div>
        )}
      </section>
      {movement_id && (
        <div className="flex container container-items-exit-test">
          <div className="flex1">
            <table className="table table-default-app">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Ref</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Tipo Und</th>
                  <th scope="col">Und. medida</th>
                  <th scope="col">Cant. a consumir</th>
                </tr>
              </thead>
              <tbody>
                
                {items.map((test) => {
                  return (
                    <tr
                    className="td-hoverme cursor-pointer"
                      style={{backgroundColor:
                        test.id === test_detail_id && "var(--line-selected)",}
                      }
                      key={test.id}
                      onClick={() =>
                        actions.getInventoryToTestAndItemId(test)
                      }
                    >
                      <td
                        className="cursor-pointer"
                        
                      >
                        {test.code}
                      </td>
                      <td>{test.name}</td>
                      <td>{getTypeMeasure(test.type_measure)}</td>
                      <td>{test.measure_name}</td>
                      <td className="txt-right">
                        {formatNumberCOP(test.out_stock)}/
                        {formatNumberCOP(test.quantity * quantity)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {status_id === STATUS_IN_PROGRESS && (
              <div style={{ marginTop: "12px" }} className="flex justify-end">
                {" "}
                <button
                  onClick={() => actions.finishOutTest()}
                  className="btn-default flex"
                >
                  <FontAwesomeIcon
                    className="margin-auto"
                    icon={faCheckCircle}
                  />
                  &nbsp; Finalizar
                </button>
              </div>
            )}
          </div>
          <div className="divisor-tables-exit-test"></div>
          <div className="flex1">
            <table className="table table-default-app">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Lote</th>
                  <th scope="col">F. vencimiento</th>
                  <th scope="col">Und. medida</th>
                  <th className="td-inventory-out-test" scope="col">
                    Cant. existente
                  </th>
                  <th scope="col">Und. medida</th>
                  <th scope="col">Cant. inventario</th>
                  <th scope="col">Consumir</th>
                  <th scope="col">Disponible</th>
                </tr>
              </thead>
              <tbody>
                {status_id === STATUS_IN_PROGRESS ? 
                  list_inventory.map((entry, index) => {
                    if (entry.date_expired === "2300-12-31") {
                      entry.lote = "N.A"
                      entry.date_expired = "N.A";
                    }
                    return (
                      <tr key={index}>
                        <td>{entry.lote}</td>
                        <td>{entry.date_expired}</td>
                        <td>{entry.abreviature}</td>
                        <td className="txt-right td-inventory-out-test">
                          {formatNumberCOP(entry.stock)}
                        </td>
                        <td>{abreviature}</td>
                        <td className="txt-right">
                          {formatNumberCOP(
                            entry.stock_in_equivalent_measure_main
                          )}
                        </td>
                        <td className="txt-right">
                          <div className="">
                            {status_id === STATUS_IN_PROGRESS ? (
                              <input
                                className="input-consume-out-test"
                                max={quantity_consume}
                                value={entry.consume}
                                onChange={(e) =>
                                  actions.setConsume(e.target.value, index)
                                }
                                onBlur={() => actions.addOutToMovement(index)}
                                type="number"
                              />
                            ) : (
                              formatNumberCOP(entry.consume)
                            )}
                          </div>
                        </td>
                        <td className="txt-right">
                          {formatNumberCOP(
                            entry.stock_in_equivalent_measure_main 
                            -
                              entry.consume
                          )}
                        </td>
                        {/* {status_id !==STATUS_EXCUTED ? 
                        <th>
                        <FontAwesomeIcon
                          onClick={() =>
                            refill(
                              entry.value_unit_conversion * entry.stock -
                                entry.consume,
                              index
                            )
                          }
                          className="blue cursor-pointer"
                          title="Consumir todo"
                          icon={faGasPump}
                        />
                      </th>
                      :
                      <></>} */}
                      </tr>
                    );
                  })
                  :
                  filter_list_inventory.map((entry, index) => {
                    if (entry.date_expired === "2300-12-31") {
                      entry.lote = "N.A"
                      entry.date_expired = "N.A";
                    }
                    if (entry.date_expired==null) {
                      entry.date_expired = "N.A";
                    }
                    return (
                      <tr key={index}>
                        <td>{entry.lote}</td>
                        <td>{entry.date_expired}</td>
                        <td>{entry.abreviature}</td>
                        <td className="txt-right td-inventory-out-test">
                          {formatNumberCOP(entry.stock)}
                        </td>
                        <td>{abreviature}</td>
                        <td className="txt-right">
                          {formatNumberCOP(
                            entry.stock_in_equivalent_measure_main
                          )}
                        </td>
                        <td className="txt-right">
                          <div className="">
                            {" "}
                            {status_id === STATUS_IN_PROGRESS ? (
                              <input
                                className="input-consume-out-test"
                                max={quantity_consume}
                                value={entry.consume}
                                onChange={(e) =>
                                  actions.setConsume(e.target.value, index)
                                }
                                onBlur={() => actions.addOutToMovement(index)}
                                type="number"
                              />
                            ) : (
                              formatNumberCOP(entry.consume)
                            )}
                          </div>
                        </td>
                        <td className="txt-right">
                          {formatNumberCOP(
                            entry.stock_in_equivalent_measure_main 
                            
                          )}
                        </td>
                        {/* {status_id !==STATUS_EXCUTED ? 
                        <th>
                        <FontAwesomeIcon
                          onClick={() =>
                            refill(
                              entry.value_unit_conversion * entry.stock
                               +
                                entry.consume
                              ,
                              index
                            )
                          }
                          className="blue cursor-pointer"
                          title="Consumir todo"
                          icon={faGasPump}
                        />
                      </th>
                      :
                      <></>} */}
                      </tr>
                    );
                  })
                }
                
              </tbody>
            </table>
          </div>
        </div>
      )}
      <PanelDocumentObservation
        documents={documents}
        observations={observations}
        actionNewObservation={actions.addObservation}
        actionNewFiles={actions.addDocumentsToMovement}
        upload_more={status_id !== STATUS_EXCUTED}
      />
    </section>
  );
};

export default TestExit;
